import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { IApplication, IJobOffer } from '../../../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class JobDescriptionService {
  private http = inject(HttpClient);

  private jobsUrl = `${environment.apiUrl}/job-offers`;

  private applicationsUrl = `${environment.apiUrl}/job-applications`;

  constructor() {}

  public getJobOffer( id: string ): Observable<IJobOffer> {
    const url = `${this.jobsUrl}/${id}`;
    return this.http.get<IJobOffer>( url );
  }

  createApplication( userId: string, jobOfferId: string, message: string, includeCv: boolean ) {
    return this.http.post<IApplication[]>( this.applicationsUrl,  { userId, jobOfferId, message, includeCv } );
  }
}
